export default function store() {
  return {};
}
